import type { ThemePreference } from '../../../shared/domain/serverPreferences/types.no-deps'
import { Imag_cache } from '../../zap/Imag/Imag.cache'

export function applyTheme(theme: ThemePreference) {
    if (theme) {
        Imag_cache(theme.logo)

        const colors = theme.colors
        setCssVars([
            { variable: '--primary-color', value: colors.primary },
            { variable: '--primary-color-highlight', value: colors.primaryHighlight },
            { variable: '--secondary-color', value: colors.secondary },
            { variable: '--green-color', value: colors.green },
            // { variable: '--green-color-background', value: colors.greenBackground },
            // { variable: '--red-color', value: colors.red },
            // { variable: '--red-color-background', value: colors.redBackground },
        ])
    } else {
        resetCssVars([
            '--primary-color',
            '--primary-color-highlight',
            '--secondary-color',
            '--green-color',
            '--green-color-background',
            '--red-color',
            '--red-color-background',
        ])
    }
}

export interface ICssVar {
    variable: string
    value: string
}

export function setCssVars(colors: ICssVar[]) {
    for (const item of colors) {
        if (!item.value) continue
        document.documentElement.style.setProperty(item.variable, item.value)
    }
}

export function resetCssVars(colors: string[]) {
    for (const item of colors) {
        document.documentElement.style.removeProperty(item)
    }
}
